import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { subscribeButtonText } from '../../ui-selectors/buttons';
import { withTranslation } from '@wix/yoshi-flow-editor';

const mapStateToProps = (state, props) => ({
  text: subscribeButtonText(state, props),
});

export default connect(mapStateToProps)(
  withTranslation()(
    class HomeView extends React.Component {
      static propTypes = {
        text: PropTypes.element,
        videoItem: PropTypes.object,

        onClick: PropTypes.func.isRequired,

        className: PropTypes.string,
        tabIndex: PropTypes.number,
      };

      render() {
        const { text, className, onClick, tabIndex = 0, t } = this.props;
        return text ? (
          <button
            type="button"
            data-hook="subscribe-button"
            className={className}
            onClick={onClick}
            tabIndex={tabIndex}
            aria-label={t('widget.mobile.subscribe-button.aria-label')}
          >
            {text}
          </button>
        ) : null;
      }
    },
  ),
);
